import { setGenericChannel } from '../../search-and-filter-schema/protected';
const updateChannelFilter = (filters, filterValue) => {
  return setGenericChannel(filterValue, filters);
};
export default updateChannelFilter;